<template>
  <div class="landing">
    <the-header />
    <landing-section-1 />
    <landing-section-2 />
    <landing-section-3 />
    <landing-section-4 />
    <landing-exchanges />
  </div>
</template>

<script>
import LandingSection1 from "@/components/Landing/LandingSection1.vue";
import LandingSection2 from "@/components/Landing/LandingSection2.vue";
import LandingSection3 from "@/components/Landing/LandingSection3.vue";
import LandingSection4 from "@/components/Landing/LandingSection4.vue";
import TheHeader from "../components/Menu/TheHeader/TheHeader.vue";
import LandingExchanges from "@/components/Landing/LandingExchanges.vue";

export default {
  name: "Landing",
  components: {
      LandingExchanges,
    LandingSection1,
    LandingSection2,
    LandingSection3,
    LandingSection4,
    TheHeader,
  },
};
</script>

<style></style>
